import React from 'react';
import { Typography, Box, Paper } from '@mui/material';

const Settings = () => (
  <Box className="page-shell">
    <Paper className="section-card" sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom fontWeight={700}>Settings Page</Typography>
      <Typography className="muted-text">This is the Settings Page.</Typography>
    </Paper>
  </Box>
);

export default Settings;
